import { useState, useEffect, useCallback } from 'react'
import { toast } from 'react-toast'
import Loader from 'components/Loader'
import emailValidation from 'utils/emailValidation'
import './contact.scss'
import { trackEvent } from 'utils/analytics1'

const SubscribeForm = ({
  onValidated,
  status,
  message,
  nameInput,
  emailInput,
  submitButton,
  sendingButton,
  messageInput
}) => {
  const [email, setEmail] = useState('')
  const [name, setName] = useState('')
  const [contents, setContents] = useState('')

  useEffect(() => {
    if (!message) return

    if (status === 'success') {
      toast.success(
        'Thank you for contacting us. We will get back to you shortly after review.'
      )
      trackEvent('Contact us', 'Submit')
      setEmail('')
      setName('')
      setContents('')
    } else toast.error(message.toString())
  }, [message, status])

  const onChangeName = useCallback(e => {
    setName(e.target.value)
  }, [])

  const onChangeEmail = useCallback(e => {
    setEmail(e.target.value)
  }, [])

  const onChangeContents = useCallback(e => {
    setContents(e.target.value)
  }, [])

  const onSubscribe = useCallback(
    e => {
      e.preventDefault()
      if (!email || !emailValidation(email)) {
        toast.error('Please enter a valid email address!')
        return
      }
      if (!name || !contents) {
        toast.error('Name and Message are required.')
        return
      }
      onValidated({
        EMAIL: email,
        MERGE1: name,
        MERGE2: contents
      })
    },
    [contents, email, name, onValidated]
  )

  return (
    <form onSubmit={onSubscribe}>
      <div className="contactform-group">
        {nameInput?.label}
        <input
          type="text"
          className="form-control"
          value={name}
          required
          onChange={onChangeName}
        />
      </div>

      <div className="contactform-group">
        {emailInput?.label}
        <input
          type="email"
          className="form-control"
          value={email}
          required
          onChange={onChangeEmail}
        />
      </div>
      <div className="contactform-group">
        {messageInput?.label}
        <textarea
          className="form-control h-auto"
          rows="6"
          value={contents}
          required
          onChange={onChangeContents}
        />
      </div>

      <button
        className="btnSubmit"
        type="submit"
        disabled={status === 'sending'}
      >
        {status === 'sending'
          ? `${sendingButton?.title}`
          : `${submitButton?.title}`}
        {status === 'sending' && (
          <div style={{ marginLeft: 10 }}>
            <Loader />
          </div>
        )}
      </button>
    </form>
  )
}

export default SubscribeForm
